import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { DeliverRequest } from "./requests";

var Axios = require("axios");

var _require = require("./auth"),
    AppsbyGlobalState = _require.AppsbyGlobalState;

var FileType = require('file-type/browser');

function GetFileMIME(_x, _x2) {
  return _GetFileMIME.apply(this, arguments);
}

function _GetFileMIME() {
  _GetFileMIME = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint, connectionParameters) {
    var toSend;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            toSend = {};
            toSend.endpoint = endpoint;
            toSend.connectionParameters = connectionParameters;
            return _context.abrupt("return", DeliverRequest(toSend, "mime", false, 120));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _GetFileMIME.apply(this, arguments);
}

function CompleteFileUpload(_x3, _x4) {
  return _CompleteFileUpload.apply(this, arguments);
}

function _CompleteFileUpload() {
  _CompleteFileUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(endpoint, key) {
    var toSend;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            toSend = {};
            toSend.endpoint = endpoint;
            toSend.key = key;
            return _context2.abrupt("return", DeliverRequest(toSend, "postupload", false, 0.001));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _CompleteFileUpload.apply(this, arguments);
}

function GenerateUploadURLAndVerifyAccess(_x5, _x6, _x7, _x8) {
  return _GenerateUploadURLAndVerifyAccess.apply(this, arguments);
}

function _GenerateUploadURLAndVerifyAccess() {
  _GenerateUploadURLAndVerifyAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(endpoint, fileName, magicBytes100Sample, connectionParameters) {
    var toSend;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            toSend = {
              endpoint: endpoint,
              fileName: fileName,
              magicBytes100Sample: JSON.stringify(Array.from(magicBytes100Sample)),
              connectionParameters: connectionParameters
            };
            return _context3.abrupt("return", DeliverRequest(toSend, "upload", false, 0.001));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _GenerateUploadURLAndVerifyAccess.apply(this, arguments);
}

function UploadFile(_x9, _x10, _x11, _x12, _x13, _x14) {
  return _UploadFile.apply(this, arguments);
}

function _UploadFile() {
  _UploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(uploadUrl, metadata, file, fileName, fileType, uploadProgressCallback) {
    var formData, config;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            formData = new FormData();
            formData.append("Content-Type", fileType.mime);
            Object.entries(metadata).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  k = _ref2[0],
                  v = _ref2[1];

              formData.append(k, v);
            });
            formData.append("file", file); // must be the last one

            config = {
              headers: {
                contentType: 'multipart/form-data'
              }
            };

            if (uploadProgressCallback) {
              config.onUploadProgress = function (progressEvent) {
                var totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                uploadProgressCallback({
                  fileName: fileName,
                  uploadPercentage: progressEvent.loaded * 100 / totalLength
                });
              };
            }

            _context4.prev = 6;
            return _context4.abrupt("return", Axios.post(uploadUrl, formData, config).then(function (result) {
              if (result.status === 204 || result.status === 200) {
                return {
                  success: true,
                  result: ""
                };
              }
            }).catch(function (result) {
              if (result.response.status === 401) {
                AppsbyGlobalState.signOut();
              } else {
                if (result.response && result.response.statusText) {
                  return {
                    success: false,
                    result: "There was an issue with your upload: ".concat(result.response.statusText)
                  };
                } else {
                  return {
                    success: false,
                    result: "Your internet connection may be offline. Check it and refresh this page."
                  };
                }
              }
            }));

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](6);
            return _context4.abrupt("return", {
              success: false,
              result: _context4.t0
            });

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[6, 10]]);
  }));
  return _UploadFile.apply(this, arguments);
}

function GetFileAddress(file, endpoint) {
  var requiresAuth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (requiresAuth) return global.baseUrl + "files/" + endpoint + "/" + file;
}

export function AppsbyUploadFile(_x15, _x16, _x17, _x18) {
  return _AppsbyUploadFile.apply(this, arguments);
}

function _AppsbyUploadFile() {
  _AppsbyUploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(endpoint, file, connectionParameters, uploadProgressCallback) {
    var mimeTypes, buf, magicBytes100Sample, fileType, safeMime, fileName, generateURLResult, uploadResult, finalizeResult;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return GetFileMIME(endpoint, connectionParameters);

          case 2:
            mimeTypes = _context5.sent;

            if (mimeTypes.success) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", {
              success: false,
              result: mimeTypes.result
            });

          case 5:
            _context5.next = 7;
            return file.arrayBuffer();

          case 7:
            buf = _context5.sent;
            magicBytes100Sample = new Uint8Array(buf).subarray(0, 100);
            _context5.next = 11;
            return FileType.fromBuffer(buf);

          case 11:
            fileType = _context5.sent;
            safeMime = false;
            mimeTypes.result.forEach(function (mime) {
              if (mime === fileType.ext) {
                safeMime = true;
              }
            });

            if (!(safeMime === false)) {
              _context5.next = 16;
              break;
            }

            return _context5.abrupt("return", {
              success: false,
              result: "This file type is not supported. You may upload: ".concat(mimeTypes.result.join(", "))
            });

          case 16:
            fileName = file.name;
            _context5.next = 19;
            return GenerateUploadURLAndVerifyAccess(endpoint, fileName, magicBytes100Sample, connectionParameters);

          case 19:
            generateURLResult = _context5.sent;

            if (generateURLResult.success) {
              _context5.next = 22;
              break;
            }

            return _context5.abrupt("return", {
              success: false,
              result: mimeTypes.result
            });

          case 22:
            _context5.next = 24;
            return UploadFile(generateURLResult.result.url, generateURLResult.result.fields, file, fileName, fileType, uploadProgressCallback);

          case 24:
            uploadResult = _context5.sent;

            if (uploadResult.success) {
              _context5.next = 27;
              break;
            }

            return _context5.abrupt("return", {
              success: false,
              result: uploadResult.result
            });

          case 27:
            _context5.next = 29;
            return CompleteFileUpload(endpoint, generateURLResult.result.fields.key);

          case 29:
            finalizeResult = _context5.sent;

            if (finalizeResult.success) {
              _context5.next = 32;
              break;
            }

            return _context5.abrupt("return", {
              success: false,
              result: finalizeResult.result
            });

          case 32:
            return _context5.abrupt("return", {
              success: true,
              result: finalizeResult.result
            });

          case 33:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _AppsbyUploadFile.apply(this, arguments);
}

export function AppsbyGetFile(_x19, _x20, _x21) {
  return _AppsbyGetFile.apply(this, arguments);
}

function _AppsbyGetFile() {
  _AppsbyGetFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(endpoint, file, requiresAuthentication) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", GetFileAddress(file, endpoint, requiresAuthentication));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _AppsbyGetFile.apply(this, arguments);
}

export function AppsbySaveFile(_x22, _x23, _x24) {
  return _AppsbySaveFile.apply(this, arguments);
}

function _AppsbySaveFile() {
  _AppsbySaveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(endpoint, file, requiresAuthentication) {
    var address;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            address = GetFileAddress(file, endpoint, requiresAuthentication);
            window.open(address, "_blank");

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _AppsbySaveFile.apply(this, arguments);
}